<template>
    <div class="ba-w-100 ba-grid ba-gp-08">
        <div class="ba-w-100 ba-flex ba-gp-08 ba-ai-center ba-jc-fe" style="height: 45px;">
            <div v-if="items.length > 0" class='ba-box-search-input ba-h-100'>
                <input  type="search" class="ba-input ba-md" :placeholder="$t('ct-search')"
                    v-model="filtro" />
                <button class='ba-button'>
                    <builderall-icon code='search' />
                </button>
            </div>
            <button type="button" class="ba-btn ba-md ba-blue ba-h-100" @click="$refs.addItem.open()" >
                <builderall-icon code='2780'></builderall-icon>
                {{ $t(`ct-create-vote`) }}
            </button>
        </div>
        <div v-if="!items.length == false" class="ba-grid ba-gp-08">
            <div class="ba-w-100 ba-grid ba-gp-08">
                <div class="ba-card ba-no-shadow ba-w-100" style="background-color: #eff2f8;">
                    <div class="ba-w-100 ba-flex ba-ai-center ba-jc-sb">
                        <span class="ba-montserrat-600">{{ $t('ct-name') }}</span>
                    </div>
                </div>
                <div class="ba-card ba-w-100 ba-blue ba-no-shadow" v-for="(item, index) of filterItems" :key="index"
                    style="height: 60px;">
                    <div class="ba-flex ba-ai-center ba-jc-sb ba-w-100 ba-h-100">
                        <span class="ba-montserrat-700 ba-text-14" style="width: 450px;"> {{ item.description }} </span>
                        <hr class="ba-hr-column" style="height: 30px;">
                        <div class="ba-flex ba-ai-center ba-gp-08">
                            <button class='ba-btn ba-btn-normal ba-sm ba-rounded' @click="$emit('voteEdit', item)" ba-tooltip-position='top'
                                :ba-tooltip-title="$t('ct-edit')">
                                <builderall-icon code='edit' />
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded' @click.prevent="duplicate(item)"
                                ba-tooltip-position='top' :ba-tooltip-title="$t('ct-duplicate')">
                                <builderall-icon code='b54c'></builderall-icon>
                            </button>
                            <button class='ba-btn ba-btn-trash ba-sm ba-rounded'
                                @click.prevent="openConfirmDelete(item)" ba-tooltip-position='top'
                                :ba-tooltip-title="$t('ct-remove')">
                                <builderall-icon code='trash' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ba-w-100" v-if="viewMore">
                <button type="button" @click="loadMore" class="ba-btn ba-blue ba-md ba-w-100">
                    {{ $t(`ct-load-more`) }}
                </button>

            </div>
        </div>
        <!--    ADD -->
        <sweet-modal ref="addItem" width="60vw" hide-close-button>
            <div class="ba-flex ba-ai-center ba-jc-sb ba-mg-b-1">
                <h5 class="ba-color-blue1">{{ $t('ct-new-vote-system') }}</h5>
                <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="$refs.addItem.close()">
                    <builderall-icon code='64f7' />
                </button>
            </div>
            <hr class='ba-hr-row'>
            <div class="ba-grid ba-mg-y-1 ba-gp-08">
                <span class="ba-custom-label">{{ $t('ct-name') }}</span>
                <input v-model="item.description" class="ba-input ba-w-100" maxlength="200"
                    :placeholder="$t(`ct-create-vote`)" rows="3" required />
            </div>
            <div class="ba-flex ba-ai-center ba-jc-fe ba-gp-1">
                <button slot="button" class="ba-btn ba-md ba-light" @click="cancelNew">{{
                    $t('ct-cancel') }}</button>
                <button slot="button" class="ba-btn ba-md ba-blue" @click.prevent="create()">{{ $t('ct-save')
                    }}</button>
            </div>
        </sweet-modal>
        <!--    DELETE -->
        <modal-delete
            :show="modalDelete.show"
            :values="remover"
            :text="remover.description"
            @cancel="cancelConfirmDelete"
            @exclude="exclude"
        ></modal-delete>
    </div>
</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import ModalDelete from "../components/ModalDelete.vue";
import { get, create as createQuestion, destroy as deleteQuestion } from "../../../js/services/editor/votesystem";

export default {
    name: "VoteList",
    components: { SweetModal, ModalDelete },
    data() {
        return {
            items: [],
            website_id: null,
            item: {
                description: "",
                website_id: null,
            },
            filtro: "",
            viewMore: false,
            remover: {},
            modalDelete: {
                show: false
            }
        };
    },
    watch: {
        type: async function () {
            this.filtro = "";
            await this.updateList();
        },

        items: function () {
            this.viewMore = this.items.length > 15 ? true : false;
        },
    },
    methods: {
        updateList() {
            this.$emit('loading', true);
            get(this.$route.params.id)
                .then((response) => {
                    this.items = response.data.data;
                    this.$emit('loading', false);
                })
                .finally(() => this.$emit('loading', false));

        },

        //   newObj() {
        //     if (this.items.length) {
        //       if (this.items[0].id === 0) {
        //         return null;
        //       }
        //     }

        //     this.items.unshift({
        //       id: 0,
        //       description: "",
        //     });
        //   },

        cancelNew() {
            this.item.description = "";
            this.$refs.addItem.close();
            // this.items.shift();
        },

        create(copy = false) {
            if (copy) {
                this.item = copy;
                this.item.description += " - copy";
            }



            this.item.website_id = this.$route.params.id;
            if (this.validate()) {
                this.$emit('loading', true);
                createQuestion(this.item)
                    .then((res) => {
                        this.$snotify.success(this.$t("ct-saved-successfully"));
                        this.item.description = ""
                        this.updateList();
                        this.$refs.addItem.close();
                        this.$emit('loading', false);
                    })
                    .finally(() => this.$emit('loading', false));
            } else {
                this.$snotify.error(this.$t(`ct-item-name-required`));
            }
        },

        validate() {
            if (!this.item.description && !(this.item.description.length > 0)) {
                return false;
            }

            return true;
        },

        openConfirmDelete(remover) {
            this.remover = remover;
            this.modalDelete.show = true;
        },

        cancelConfirmDelete() {
            this.remover = {};
            this.modalDelete.show = false;
        },

        exclude() {
            this.$emit('loading', true);
            deleteQuestion(this.remover)
                .then((res) => {
                    this.modalDelete.show = false;
                    this.updateList();
                    this.$emit('loading', false);
                })
                .finally(() => this.$emit('loading', false));
        },

        duplicate(item) {
            item.website_id = this.$route.params.id;
            this.create(item);
        },

        loadMore() { },
    },
    async created() {
        await this.updateList();
    },
    computed: {
        filterItems() {
            return this.items.filter((item) => {
                return item.description.match(this.filtro);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
header form {
    position: relative;
    height: 47px;
    margin-right: 20px;

    i {
        position: absolute;
        left: 20px;
        top: 15px;
    }

    input {
        height: -webkit-fill-available;
        padding-left: 45px;
    }
}

section {
    .card-tags-group {
        font-family: Lato;
        text-transform: uppercase;

        .card-header,
        textarea {
            font-size: 18px;
            color: #0080fc;
            font-weight: 700;
            text-align: center;
        }

        form textarea {
            border: none;
            background: transparent;
            padding: 0;
            resize: none;

            &::placeholder {
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: #0080fc;
                opacity: 1;
                /* Firefox */
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: #0080fc;
            }

            &::-ms-input-placeholder {
                /* Microsoft Edge */
                color: #0080fc;
            }
        }

        .card-body {
            display: flex;
            flex-direction: row;
            justify-content: center;
        }
    }

    .sombra {
        box-shadow: 0 0 0 100vw #59607175;
        z-index: 2;
    }

    .btn-grey {
        background: #fcfcfc;
        padding: 25px 0 !important;
        font-weight: 600 !important;
    }
}

.btn .svgi-trash {
    filter: brightness(5);
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/VoteList.vue